import React from "react";
import { Input } from "../../../../shadcn/ui/input";
import { Clock } from "lucide-react";

const TimeInput = ({ defaultValue, disabled, value, onChange }: any) => {
  const handleChange = (e: any) => {
    if (typeof onChange === "function") {
      if (e.target) {
        onChange(e.target.value);
      } else {
        onChange(e);
      }
    }
  };

  return (
    <div className="relative flex items-center">
      <Input
        type="time"
        value={value || defaultValue}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange(e.target.value)}
        className="bg-slate-100 border-slate-200 pr-8"
        disabled={disabled}
        {...({} as any)}
      />
      <Clock className="absolute right-2 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
    </div>
  );
};

export default TimeInput;
